import {useSelector} from 'react-redux';

import appConfig from '../../../../config/appConfig';
import marketConfigService from '../../../../services/marketConfigService';
import productService from '../../../../services/product/productService';
import {selectIsScpCheckInProgress} from '../../../../state/selectors/global';

const useRenameDeviceEnabled = (iotDevice) => {
    const isScpCheckInProgress = useSelector(selectIsScpCheckInProgress);
    const isDeviceSettingAvailable = appConfig.getIsDeviceSettingAvailable();
    const isCurrentProductRegistered = isScpCheckInProgress
        ? true
        : productService.getIsRegistered(iotDevice.device?.status);
    const isDeviceRenameEnabledByMarket = marketConfigService.isDeviceRenameEnabled();
    const isRegistrationPromoted = appConfig.getIsRegistrationPromoted();

    return (
        (isCurrentProductRegistered || isRegistrationPromoted) &&
        isDeviceSettingAvailable &&
        isDeviceRenameEnabledByMarket
    );
};

export default useRenameDeviceEnabled;
